import React from 'react';

/**
 * Основная часть приложения
 */
const SkeletonComponent = React.lazy(() => import('../components/Skeleton/Skeleton.component'));
const HomeComponent = React.lazy(() => import('../components/Home/Home'));
const MainContentWrapperComponent = React.lazy(
  () => import('../components/MainContentWrapper/MainContentWrapper.component'),
);
const ThemeSettingsComponent = React.lazy(
  () => import('../components/Theme/ThemeSettingsComponent/ThemeSettings.component'),
);
const ThemeEditor = React.lazy(() => import('../components/Theme/ThemeEditor/ThemeEditor'));
const AboutPageComponent = React.lazy(
  () => import('../components/AboutComponent/AboutPage.component'),
);
const Callback = React.lazy(() => import('../components/CallbackComponent/CallbackComponent'));

/**
 * Профиль пользователя
 */
const ProfileLayout = React.lazy(
  () => import('../components/Profile/ProfileLayoutComponent/ProfileLayoutComponent'),
);
const ProfileViewComponent = React.lazy(
  () => import('../components/Profile/ProfileViewLayoutComponent/ProfileViewLayoutComponent'),
);
const SecuritySectionComponent = React.lazy(
  () =>
    import(
      '../components/Profile/ProfileSectionsComponents/SecuritySection/SecuritySectionComponent'
    ),
);
const ThemeSectionComponent = React.lazy(
  () =>
    import('../components/Profile/ProfileSectionsComponents/ThemeSection/ThemeSectionComponent'),
);
const PrivacySectionComponent = React.lazy(
  () =>
    import(
      '../components/Profile/ProfileSectionsComponents/PrivacySection/PrivacySectionComponent'
    ),
);

const Guard = React.lazy(() => import('../components/Guard/Guard'));

/**
 * error
 */
const ErrorWrapper = React.lazy(() => import('../components/Error/ErrorWrapper'));

export {
  SkeletonComponent,
  HomeComponent,
  MainContentWrapperComponent,
  ThemeSettingsComponent,
  ThemeEditor,
  AboutPageComponent,
  Callback,
  ProfileLayout,
  ProfileViewComponent,
  SecuritySectionComponent,
  ThemeSectionComponent,
  PrivacySectionComponent,
  ErrorWrapper,
  Guard,
};
